import {firstTag} from '@/config'

const common = {
    state: {
        tabTags: [firstTag],  //getLocalStorageObject('tabTags') ||
    },
    mutations: {
        ADD_TAG: (state, tag) => {
            if (!(tag.meta && tag.meta.tag) || state.tabTags.some(e => e.path == tag.path)) return
            state.tabTags.push(tag)
            localStorage.setItem('tabTags', JSON.stringify(state.tabTags))
        },
        DEL_TAG: (state, tag) => {
            state.tabTags = state.tabTags.filter(item => {
                return item.path !== tag.path
            })
            localStorage.setItem('tabTags', JSON.stringify(state.tabTags))
        },
        DEL_ALL_TAG: (state) => {
            state.tabTags = []
            localStorage.setItem('tabTags', JSON.stringify(state.tabTags))
        },
        DEL_TAG_OTHER: (state, tag) => {
            state.tabTags = state.tabTags.filter(item => {
                return [tag, firstTag].includes(item.path)
            })
            localStorage.setItem('tabTags', JSON.stringify(state.tabTags))
        }
    },
    actions: {}
}
export default common
